
  import apiService from '../services/api.service'
  import { getProductDimensions } from "../utils/autocompleteProducts";
  import { KG_TO_LBS } from '../constants/weightConversion'

  let productDimensions = {};

  function getBase64Image(url) {
    return new Promise((resolve, reject) => {
      console.log("Convert image to Base64");
      console.log(url);
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function() {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        try {
          const dataUrl = canvas.toDataURL();
          resolve(dataUrl);
        } catch (error) {
          console.error("error generating image base64", error);
          reject(error);
        }
      };
      // Set attributes and src
      img.src = url;
      img.setAttribute('crossOrigin', '');
    });
}

function getProductInfo(name, property)
{
  if (productDimensions[name]) {
    return productDimensions[name][property];
  }
  return null;
}

function formatCurrency(num) {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
  return formatter.format(num); /* $2,500.00 */
}

const tableInfoLayout = {
  hLineWidth: function (i, node) { return 0; },
  vLineWidth: function (i, node) { return 0; },
  paddingLeft: function(i, node) { return 5; },
  paddingRight: function(i, node) { return 5; },
  paddingTop: function(i, node) { return 1; },
  paddingBottom: function(i, node) { return 1; },
};

export const generatePickupOrder = async (rfq, rfqId) => {

  productDimensions = await getProductDimensions();
  if (!productDimensions) {
    throw Error("inventory is missing!");
  }

  console.log(rfq);
  const imageBase64 = await getBase64Image('static/img/diva-address-pink.jpg');

  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const today = (new Date()).toLocaleDateString("en-US", options);
  const pickupDate = (new Date(rfq.shipper.pickupDateTime)).toLocaleDateString("en-US", options);
  const deliveryDate = (new Date(rfq.consignee.deliveryDateTime)).toLocaleDateString("en-US", options);
  

  let assigneeInfo = 'No Quote awarded yet.';
  let assigneePre = '';
  let awardedAssignee;
  if (Array.isArray(rfq.assignees)) {
    try {
      awardedAssignee = rfq.assignees.find( (assignee) => assignee.quote && assignee.quote.status == "Awarded");
      if (awardedAssignee) {
        const assigneeDetails = await apiService.get('/kong/api/v1/entity/id', {
          headers: { 'X-Raefton-ID': awardedAssignee.assigneeid }
        });
        assigneePre = ' - For Confirmation and any questions please contact';
        assigneeInfo = assigneeDetails.data.Result.name + " " + assigneeDetails.data.Result.phone;
        awardedAssignee.phonecell = assigneeDetails.data.Result.phonecell;
        awardedAssignee.phoneoffice = assigneeDetails.data.Result.phoneoffice;
        awardedAssignee.fax = assigneeDetails.data.Result.fax;
      }
    } catch(e) {
      assigneeInfo = `No assignee found ${e}`;
    }
  }

  let shippingUnitArray = [[ 'Item Name', 'Packages', 'Units' ]];
  let itemsRollup = {};
  const totals = { totalReportedCases: 0, totalShippmentValue: 0, totalSkids: 0, totalUnits: 0 };

  let totalWeight = 0;
  if (Array.isArray(rfq.shippingunit))
  {
    for (let i = 0; i < rfq.shippingunit.length; i++)
    {
      // count all skids at the primary level
      if (Array.isArray(rfq.shippingunit[i].components) && rfq.shippingunit[i].components.length > 0 && 
          rfq.shippingunit[i].type == 'Skid') {
        totals.totalSkids += Number(rfq.shippingunit[i].quantity);
      }

      let weight = Number(rfq.shippingunit[i].weight);
      if (rfq.shippingunit[i].unitsofmeasure.indexOf("kgs") > 0) {
        weight = Math.round(weight*KG_TO_LBS*10)/10;
      }
      totalWeight += Math.round(weight);

      const isHoldingSecondaryUnits = Array.isArray(rfq.shippingunit[i].components) && rfq.shippingunit[i].components.length > 0;
      if (!isHoldingSecondaryUnits) {
        rollUpShippingUnit(1, totals, itemsRollup, rfq.shippingunit[i]);
      } else {
        for (let j = 0; j < rfq.shippingunit[i].components.length; j++)
        {
          const secondaryUnit = rfq.shippingunit[i].components[j];
          const isHoldingPrimaryUnits = Array.isArray(secondaryUnit.components) && secondaryUnit.components.length > 0;
          if (isHoldingPrimaryUnits) {

            // if an item at the secondary level is composed of primary items inside of it, it also counts as a "case" or "package" for the
            // purposes of a pickup order. (in addition to pre-packaged things like 6-packs which are already counted in rollUpShippingUnit)
            const externalCasesByProduct = new Map();

            const multiplier = secondaryUnit.quantity*rfq.shippingunit[i].quantity;
            for (let k = 0; k < secondaryUnit.components.length; k++) {
              rollUpShippingUnit(multiplier, totals, itemsRollup, secondaryUnit.components[k]);
              externalCasesByProduct.set(secondaryUnit.components[k].description, multiplier);
            }
            
            // add in the additional tallied cases
            totals.totalReportedCases += multiplier;
            for (const desc of externalCasesByProduct.keys()) {
              if (itemsRollup[desc]) {
                itemsRollup[desc].cases += externalCasesByProduct.get(desc);
              }
            }

          } else {
            rollUpShippingUnit(rfq.shippingunit[i].quantity, totals, itemsRollup, secondaryUnit);
          }
        }
      }
    }

    shippingUnitArray = [...shippingUnitArray, ...Object.keys(itemsRollup).map((productDescription) => {
      const shippingUnit = itemsRollup[productDescription];
      const unitsPerCase = getProductInfo(productDescription, 'unitsPerCase');
      let cases = shippingUnit.cases;
      let units = unitsPerCase ? `${shippingUnit.units}` : 'N/A'
      const desc = `${productDescription}\n${unitsPerCase || 'N/A'} units per package`;
      return [desc, `${cases}`, units];
    })];
  }

  const dd = {
    images: {
      footerImage: imageBase64,
    },
    // header: { text: 'SF-75-01-1 REV. B', margin: [5, 5], fontSize: 10, },
    pageMargins: [ 40, 40, 40, 80 ],
    footer: function(currentPage, pageCount) { 
      return  [
        {
          image: 'footerImage',
          alignment: 'center',
          width: 400,
        },
        { text: `Page ${currentPage.toString()} of ${pageCount}`, alignment: 'center', color: '#333' },
      ]; 
    },
    content: [
        { text: 'PICK UP ORDER', alignment: 'center', fontSize: 16, margin: [0, 0, 0, 30]},
        {
          columns: [
            {
              style: 'tableInfo',
              table: {
                widths: [100, '*'],
                body: [
                  [{text: 'Customer', style: 'tableHeader', colSpan: 2, margin: [5, 0, 0, 0]}, ''],
                  [{text: 'Company Name: ', style: 'cellLabel', alignment: 'right'},  {text: rfq.customer.company, style: 'cellValue'}],
                  [{text: 'Address: ', style: 'cellLabel', alignment: 'right'}, {style: 'cellValue', text: `${rfq.customer.address}\n${rfq.customer.city}, ${rfq.customer.province}, ${rfq.customer.postal}\n${rfq.customer.country}`}],
                  [{text: 'Date: ', style: 'cellLabel', alignment: 'right'}, {text: today, style: 'cellValue'}],
                  [{text: 'Transfer Order: ', style: 'cellLabel', alignment: 'right'}, {text: rfq.customer.transferOrder, style: 'cellValue'}],
                  [{text: 'Shipment ID: ', style: 'cellLabel', alignment: 'right'}, {text: rfqId, style: 'cellValue'}]
                ]
              },
              layout: tableInfoLayout
            },
            {
              style: 'tableInfo',
              table: {
                widths: [100, '*'],
                body: [
                  [{text: 'Carrier', style: 'tableHeader', colSpan: 2, margin: [5, 0, 0, 0]}, ''],
                  [{text: 'Company Name: ', style: 'cellLabel', alignment: 'right'},  {text: (awardedAssignee) ? awardedAssignee.assigneeCompany : '', style: 'cellValue'}],
                  [{text: 'Address: ', style: 'cellLabel', alignment: 'right'}, {style: 'cellValue', text: (awardedAssignee) ? `${awardedAssignee.address}\n${awardedAssignee.city}, ${awardedAssignee.province}, ${awardedAssignee.postal}\n${awardedAssignee.country}` : ''}],
                  [{text: 'Contact: ', style: 'cellLabel', alignment: 'right'}, {text: (awardedAssignee) ? awardedAssignee.assigneeName  : '', style: 'cellValue'}],
                  [{text: 'Phone: ', style: 'cellLabel', alignment: 'right'}, {text: (awardedAssignee) ?  awardedAssignee.phonecell : '', style: 'cellValue'}],
                  [{text: 'Fax: ', style: 'cellLabel', alignment: 'right'}, {text: (awardedAssignee) ?  awardedAssignee.fax : '', style: 'cellValue'}]
                ]
              },
              layout: tableInfoLayout
            }
          ]
        },
        {
          columns: [
            {
              style: 'tableInfo',
              table: {
                widths: [100, '*'],
                body: [
                  [{text: 'Ship From', style: 'tableHeader', colSpan: 2, margin: [5, 0, 0, 0]}, ''],
                  [{text: 'Pick Up Date: ', style: 'cellLabel', alignment: 'right'},  {text: pickupDate, style: 'cellValue'}],
                  [{text: 'Company Name: ', style: 'cellLabel', alignment: 'right'},  {text: rfq.shipper.company, style: 'cellValue'}],
                  [{text: 'Address: ', style: 'cellLabel', alignment: 'right'}, {style: 'cellValue', text: `${rfq.shipper.address}\n${rfq.shipper.city}, ${rfq.shipper.province}, ${rfq.shipper.postal}\n${rfq.shipper.country}`}],
                  [{text: 'Contact: ', style: 'cellLabel', alignment: 'right'}, {text: rfq.shipper.name, style: 'cellValue'}],
                  [{text: 'Phone: ', style: 'cellLabel', alignment: 'right'}, {text: rfq.shipper.contactPhone, style: 'cellValue'}],
                  [{text: 'Fax: ', style: 'cellLabel', alignment: 'right'}, {text: rfq.shipper.fax, style: 'cellValue'}]
                ]
              },
              layout: tableInfoLayout
            },
            {
              style: 'tableInfo',
              table: {
                widths: [100, '*'],
                body: [
                  [{text: 'Ship To', style: 'tableHeader', colSpan: 2, margin: [5, 0, 0, 0]}, ''],
                  [{text: 'Pick Up Date: ', style: 'cellLabel', alignment: 'right'},  {text: deliveryDate, style: 'cellValue'}],
                  [{text: 'Company Name: ', style: 'cellLabel', alignment: 'right'},  {text: rfq.consignee.company, style: 'cellValue'}],
                  [{text: 'Address: ', style: 'cellLabel', alignment: 'right'}, {style: 'cellValue', text: `${rfq.consignee.address}\n${rfq.consignee.city}, ${rfq.consignee.province}, ${rfq.consignee.postal}\n${rfq.consignee.country}`}],
                  [{text: 'Contact: ', style: 'cellLabel', alignment: 'right'}, {text: rfq.consignee.name, style: 'cellValue'}],
                  [{text: 'Phone: ', style: 'cellLabel', alignment: 'right'}, {text: rfq.consignee.contactPhone, style: 'cellValue'}],
                  [{text: 'Fax: ', style: 'cellLabel', alignment: 'right'}, {text: rfq.consignee.fax, style: 'cellValue'}]
                ]
              },
              layout: tableInfoLayout
            }
          ]
        },

        {
          layout: 'lightHorizontalLines',
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: [ '*', 'auto', 100 ],
            body: shippingUnitArray,
          },
          margin: [0, 15]
        },
        {
          columns: [
            {
              style: 'tableInfo',
              table: {
                widths: [100, '*'],
                body: [
                  [{text: 'Shipment Summary', style: 'tableHeader', colSpan: 2, margin: [5, 0, 0, 0]}, ''],
                  [{text: 'Total Weight: ', style: 'cellLabel', alignment: 'right'},  {text: `${totalWeight} LBS`, style: 'cellValue', bold: true}],
                  [{text: 'Shipping Units: ', style: 'cellLabel', alignment: 'right'}, {style: 'cellValue', text: `${totals.totalSkids} SKIDS`}],
                  [{text: 'Cases: ', style: 'cellLabel', alignment: 'right'}, {text: `${totals.totalReportedCases} CASES`, style: 'cellValue'}],
                  [{text: 'Units: ', style: 'cellLabel', alignment: 'right'}, {text: `${totals.totalUnits} UNITS`, style: 'cellValue'}]
                ]
              },
              layout: tableInfoLayout
            },
            {
              style: 'tableInfo',
              table: {
                widths: ['*'],
                body: [
                  [{text: 'Special Instructions', style: 'tableHeader', margin: [5, 0, 0, 0]}],
                  [{text: `Please mark on outside:`, style: 'cellLabel', bold: true}],
                  [{text: `"DO NOT STACK PALLETS" and "Handle with Care"`, style: 'cellLabel', bold: true}]
                ]
              },
              layout: tableInfoLayout
            },
          ]
        },
    ],
    defaultStyle: {
      columnGap: 10,
      fontSize: 10
    },
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10]
      },
      subheader: {
        fontSize: 16,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      tableInfo: {
        fontSize: 10,
        margin: [0, 5, 0, 15]
      },
      tableHeader: {
        bold: true,
        fillColor: '#DDD',
        color: 'black'
      },
      cellValue: {
        italics: true
      }
    },
  };

  return pdfMake.createPdf(dd)
}

function rollUpShippingUnit(multiplier, totals, itemsRollup, unit, preferFullRollupDescription) {
  let productDescription = unit.description;
  let unitPrice = getProductInfo(productDescription, 'pricePerUnit');
  let FDACode = getProductInfo(productDescription, 'fda');
  let productCode = getProductInfo(productDescription, 'productCode');
  let origin = getProductInfo(productDescription, 'origin');
  let isContainer = getProductInfo(productDescription, 'isContainer');
  if (isNaN(unitPrice)) {
    unitPrice = 0;
  }

  // for now only put items on the proforma if they have an htsCode. Non-Diva items will be excluded.
  let htsCode = getProductInfo(productDescription, 'htsCode');
  if (htsCode) {
    const description = getProductInfo(productDescription, 'rollupDescription') || unit.description;
    const unpacked = getProductInfo(productDescription, 'unpacked');
    const unitsPerCase = Number(getProductInfo(productDescription, 'unitsPerCase'));

    let packedCases = Number(unit.quantity*multiplier);
    // this is to work around problems with incorrect NetSuite "Each" labeling on items
    if (unpacked) packedCases = Math.ceil(packedCases / unitsPerCase);

    const rollupKey = preferFullRollupDescription ? description : productDescription;
    const units = packedCases*unitsPerCase;
    const totalPrice = units*unitPrice;
    const numReportedCases = isContainer ? packedCases : 0;

    totals.totalReportedCases += numReportedCases;
    totals.totalUnits += units;
    totals.totalShippmentValue += totalPrice;
    if (itemsRollup[rollupKey]) {
      itemsRollup[rollupKey].totalPrice += totalPrice;
      itemsRollup[rollupKey].cases += numReportedCases;
      itemsRollup[rollupKey].units += units;
      // recompute units cost in case of different prices
      itemsRollup[rollupKey].unitPrice = itemsRollup[rollupKey].totalPrice / itemsRollup[rollupKey].units;
    } else {
      itemsRollup[rollupKey] = { htsCode, unitPrice, totalPrice, FDACode, productCode, origin, cases: numReportedCases, units };
    }
  }
}

export const generateProForma = async (rfq) => {

  const customerCompanyResp = await apiService.get(`/company/${rfq.customer.companyEntity}`);
  const customerCompany = customerCompanyResp.data;
  console.log(customerCompany);

  productDimensions = await getProductDimensions();
  if (!productDimensions) {
    throw Error("inventory is missing!");
  }


  const shippingDate = (new Date(rfq.shipper.pickupDateTime)).toLocaleDateString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' });
  const sm = 6;
  const md = 11;
  const chk = 9;

  const shippingUnitArray = [[
    { fontSize: sm, text: '16. COUNTRY OF MANUFACTURE OR GROWTH'},
    { fontSize: sm, text: ' '},
    { fontSize: sm, text: '13. QUANTITY'},
    { fontSize: sm, text: '14. UNIT PRICE'},
    { fontSize: sm, text: '15. TOTAL'},
  ]];


  const itemsRollup = {};
  const totals = { totalReportedCases: 0, totalShippmentValue: 0, totalUnits: 0 };
  let totalWeight = 0;
  if (Array.isArray(rfq.shippingunit))
  {
    for (let i = 0; i < rfq.shippingunit.length; i++)
    {
      let weight = Number(rfq.shippingunit[i].weight);
      if (rfq.shippingunit[i].unitsofmeasure.indexOf("kgs") > 0) {
        weight = Math.round(weight*KG_TO_LBS*10)/10;
      }
      totalWeight += Math.round(weight);

      const isHoldingSecondaryUnits = Array.isArray(rfq.shippingunit[i].components) && rfq.shippingunit[i].components.length > 0;
      if (!isHoldingSecondaryUnits) {
        rollUpShippingUnit(1, totals, itemsRollup, rfq.shippingunit[i], true);
      } else {
        for (let j = 0; j < rfq.shippingunit[i].components.length; j++)
        {
          const secondaryUnit = rfq.shippingunit[i].components[j];
          const isHoldingPrimaryUnits = Array.isArray(secondaryUnit.components) && secondaryUnit.components.length > 0;
          if (isHoldingPrimaryUnits) {

            const multiplier = secondaryUnit.quantity*rfq.shippingunit[i].quantity;
            for (let k = 0; k < secondaryUnit.components.length; k++) {
              rollUpShippingUnit(multiplier, totals, itemsRollup, secondaryUnit.components[k], true);
            }

            // add in the additional non-package cases
            totals.totalReportedCases += multiplier;

          } else {
            rollUpShippingUnit(rfq.shippingunit[i].quantity, totals, itemsRollup, secondaryUnit, true);
          }
        }
      }
    }

    const htsDescriptions = Object.keys(itemsRollup);
    htsDescriptions.forEach( (htsDescription) => {
      console.log(htsDescription);
      const htsCode = itemsRollup[htsDescription].htsCode;
      let productCodes = '';
      if (itemsRollup[htsDescription].FDACode || itemsRollup[htsDescription].productCode) {
        productCodes = `\nFDA Code: ${itemsRollup[htsDescription].FDACode}\nProduct Code - ${itemsRollup[htsDescription].productCode}`;
      }
      const row = [
        { fontSize: md, text: `${itemsRollup[htsDescription].origin}`, alignment: 'center', margin: [0,5,0,5]},
        { fontSize: md, text: `${htsDescription}\nHTS#${htsCode} ${productCodes}`, alignment: 'center', margin: [0,5,0,5]},
        { fontSize: md, text: String(itemsRollup[htsDescription].units), alignment: 'center', margin: [0,5,0,5] },
        { fontSize: md, text: formatCurrency(itemsRollup[htsDescription].unitPrice), alignment: 'right', margin: [0,5,0,5]},
        { fontSize: md, text: formatCurrency(itemsRollup[htsDescription].totalPrice), alignment: 'right', margin: [0,5,0,5] },
      ];      
      shippingUnitArray.push(row);
    });
  }

  let outlineLayout = {
    hLineWidth: function (i, node) {
      return i == 0 ? 1 : 0;
    },
    vLineWidth: function (i, node) {
      return 1;
    }
  }

  let bottomLeftLayout = {
    hLineWidth: function (i, node) {
      return i;
    },
    vLineWidth: function (i, node) {
      return i == 0 ? 1 : 0;
    }
  }

  let topLayout = {
    hLineWidth: function (i, node) {
      return i == 0 ? 1 : 0;
    },
    vLineWidth: function (i, node) {
      return 0;
    }
  }

  let blankLayout = {
    hLineWidth: function (i, node) {
      return 0;
    },
    vLineWidth: function (i, node) {
      return 0;
    }
  }

  var dd = {
    images: {
      checked: 'data:image/png;base64,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',
      unchecked: 'data:image/png;base64,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',
    },
    header: function(currentPage, pageCount, pageSize) {
      return {
        margin: [0, 20, 0, 10],
        table: {
          widths: [90, 1, '*', 1, 90],
          body: [
            [
              ' ',
              ' ',
              { text: 'PRO FORMA INVOICE', alignment: 'center', bold: true },
              ' ',
              { text: `PAGE ${currentPage} of ${pageCount}`, alignment: 'right', fontSize: chk, margin: [0, 4, 36, 0] }
            ]
          ]
        },
        layout: blankLayout,
      }
    },
    content: [
      {
        margin: [0, 0],

        // first row section
        table: {
          widths: ['40%','60%'],
          body: [
            [
              
              // first column 50%
              {
                stack: [
                  {
                    table: {
                      widths: ['*'],
                      body: [
                        [
                          {
                            stack: [
                              { fontSize: sm, text: '1. SELLER OR EXPORTER', margin: [0, 0, 0, 5] },
                              { fontSize: md, text: rfq.customer.company },
                              { fontSize: md, text: rfq.customer.address },
                              { fontSize: md, text: `${rfq.customer.city}, ${rfq.customer.province}, ${rfq.customer.postal}    #${rfq.customer.transferOrder}` },
                              { fontSize: md, text: `FDA Registration #${customerCompany.fdaRegistration}`, margin: [0, 4, 0, 4]},
                            ]
                          }
                        ]
                      ]                                                              
                    },
                    layout: blankLayout,
                  },
                  { table: { widths: ['100%'], body : [['']]}, layout: topLayout},
                  {
                    table: {
                      widths: [80, '*'],
                      body: [
                        [
                          { fontSize: sm, text: '4. CONSIGNEE', margin: [0, 0, 0, 5] },
                          { 
                            table: {
                              widths: ['*'],
                              body: [
                                [
                                  {
                                    stack: [
                                      { fontSize: sm, text: 'TAX I.D.' },
                                      { text: ' ', margin: [0, 3] }
                                    ]
                                  }
                                ]
                              ]                                                             
                            },
                            layout: bottomLeftLayout,
                          },
                        ],
                      ]
                    },
                    layout: blankLayout,
                  },
                  {
                    table: {
                      widths: ['*'],
                      body: [
                        [
                          {
                            stack: [
                              { fontSize: md, text: `${rfq.consignee.company}`},
                              { fontSize: md, text: rfq.consignee.address },
                              { fontSize: md, text: `${rfq.consignee.city}, ${rfq.consignee.province}, ${rfq.consignee.postal}`, margin: [0, 0, 0, 4] }
                            ]
                          },
                        ]
                      ]                                                              
                    },
                    layout: blankLayout,
                  }
                ]
              },

              // second column
              {
                stack: [
                  {
                    table: {
                      widths: [140, '*'],
                      body: [
                        [
                          { fontSize:md, text: 'FOR U.S. CUSTOMS\nCLEARANCE NOTIFY:' },
                          { 
                            table: {
                              widths: ['*'],
                              body: [
                                [
                                  {
                                    stack: [
                                      { fontSize: sm, text: '2. REFERENCE NO.' },
                                      { text: ' ', margin: [0, 10] }
                                    ]
                                  }
                                ]
                              ]                                                             
                            },
                            layout: bottomLeftLayout,
                          },
                        ]
                      ]                                                              
                    },
                    layout: blankLayout,
                  },
                  { fontSize: 14, text: customerCompany.customsBroker, margin: [0, 20], bold: true, alignment: 'center' },
                  { fontSize: sm, text: 'RELEASE OFFICE LOCATIONS: NAFTA ON FILE', margin: [0, 4], bold: true, alignment: 'left' },
                ]

              },
              
            ]
          ]                                                              
        },
        layout: outlineLayout,
      },


      // second row section
      {
        table: {
          widths: ['40%','60%'],
          body: [
          [
            {
              stack: [
                {
                  table: {
                    widths: ['*'],
                    body: [
                      [
                        {
                          stack: [
                            { fontSize: sm, text: '5. BUYER OR OTHER', margin: [0, 0, 0, 5] },
                            { fontSize: sm, text: ' ', margin: [0, 20] },
                          ]
                        }
                      ]
                    ]                                                              
                  },
                  layout: blankLayout,
                },
                {
                  table: {
                    widths: ['*'],
                    body: [
                      [
                        {
                          stack: [
                            { fontSize: sm, text: '10. EXPORTING CARRIER', margin: [0, 0, 0, 5] }
                          ]
                        }
                      ]
                    ]                                                              
                  },
                  layout: topLayout,
                }
              ]
            },
            {
              stack: [
                {
                  table: {
                    widths: ['*'],
                    body: [
                      [
                        {
                          stack: [
                            { fontSize: sm, text: '6. COUNTRY OF DESTINATION', margin: [0, 0, 0, 5] },
                            { fontSize: md, text: rfq.consignee.country },
                          ]
                        }
                      ]
                    ]                             
                  },
                  layout: blankLayout,
                },
                {
                  table: {
                    widths: ['*'],
                    body: [
                      [
                        {
                          stack: [
                            { fontSize: sm, text: '7. TERMS OF DELIVERY AND PAYMENT', margin: [0, 5, 0, 5] },
                            {
                              table: {
                                widths: ['auto', 1, 'auto', 1, 'auto', 1, 'auto'],
                                body: [
                                  [
                                    { fontSize: sm, text: 'F.O.B: ', margin: [0, 6, 0, 0] },
                                    { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                                    { margin: [4,4,0,0], fontSize: chk, text: 'PLANT' },
                                    { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                                    { margin: [4,4,0,0], fontSize: chk, text: 'DESTINATION' },
                                    { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                                    { margin: [4,4,0,0], fontSize: chk, text: 'OTHER' },
                                  ]
                                ]                                                              
                              },
                              layout: blankLayout,
                            },
                            {
                              table: {
                                widths: ['auto', 1, 'auto', 1, 'auto', ],
                                body: [
                                  [
                                    { fontSize: sm, text: 'PARTIES TO TRANSACTION: ', margin: [0, 6, 0, 0] },
                                    { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                                    { margin: [4,4,0,0], fontSize: chk, text: 'RELATED' },
                                    { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                                    { margin: [4,4,0,0], fontSize: chk, text: 'NON-RELATED' },
                                  ]
                                ]                                                              
                              },
                              layout: blankLayout,
                            },
                            {
                              table: {
                                widths: ['auto', 1, 'auto', 1, 'auto', 1, 'auto',],
                                body: [
                                  [
                                    { fontSize: sm, text: 'DUTIES AND\nBROKERAGE:', margin: [0, 0, 0, 0] },
                                    { margin: [0,4,0,0], image: 'checked', width: 10 },
                                    { margin: [4,4,0,0], fontSize: chk, text: 'SELLER' },
                                    { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                                    { margin: [4,4,0,0], fontSize: chk, text: 'CONSIGNEE' },
                                    { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                                    { margin: [4,4,0,0], fontSize: chk, text: 'OTHER: __________' },
                                  ]
                                ]                                                              
                              },
                              layout: blankLayout,
                            },
                            { table: { widths: ['100%'], body : [['']]}, layout: topLayout, margin: [0, 4, 0, 0]},
                            { fontSize: sm, text: '11. PRICES BELOW INCLUDE:' },
                            {
                              table: {
                                widths: [1, 'auto', 1, 'auto', 1, 'auto', 1, 'auto'],
                                body: [
                                  [
                                   
                                    { margin: [0,4,0,0], image: 'checked', width: 10 },
                                    { margin: [4,4,0,0], fontSize: chk, text: 'DUTY' },
                                    { margin: [0,4,0,0], image: 'checked', width: 10 },
                                    { margin: [4,4,0,0], fontSize: chk, text: 'BROKERAGE' },
                                    { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                                    { margin: [4,4,0,0], fontSize: chk, text: 'FREIGHT' },
                                    { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                                    { margin: [4,4,0,0], fontSize: chk, text: 'DISCOUNT: _________' },
                                  ]
                                ]                                                              
                              },
                              layout: blankLayout,
                            }
                          ]
                        }
                      ]
                    ],
                  },
                  layout: topLayout,
                }
              ]
            }
          ]
        ]
      }
    },


    // third row section package totals
    {
      table: {
        widths: ['50%', '18%', '*'],
        body: [
          [
            { fontSize: sm, text: 'NUMBER AND TYPE OF PACKAGES, DESCRIPTION OF ARTICLES', border: [true,false,true,false] },
            { fontSize: sm, text: '12. GROSS WEIGHT', border: [true,false,true,false] },
            { fontSize: sm, text: 'CURRENCY', border: [true,false,true,false] },
          ],
          [
            { fontSize: md, text: `${totals.totalReportedCases} Cases`, alignment: 'center', border: [true,false,true,false] },
            { fontSize: md, text: `${totalWeight} lbs`, alignment: 'center', border: [true,false,true,false] },
            { fontSize: md, text: 'US$', alignment: 'center', border: [true,false,true,false] },
          ]

        ]
      }
    },

    // 4th row items
    {
      table: {
        widths: ['9.7%', '40.9%', '18.4%', '12%', '*'],
        body: shippingUnitArray,
      },
      layout: outlineLayout,
    },

    // 5th row totals
    {
      table: {
        widths: ['69.9%', '11.8%', '*'],
        body: [
          [
            { fontSize: md, text: 'For Customs Clearance in Detroit / Port Huron, MI please see ourPort Huron, MI'},
            { fontSize: md, text: 'TOTAL', alignment: 'center' },
            { fontSize: md, text: formatCurrency(totals.totalShippmentValue), alignment: 'right' },
          ]
        ]
      },
      layout: outlineLayout,
    },

    // 6th row text
    {
      table: {
        widths: ['*'],
        body: [
          [
            { 
              margin: [0, 10], 
              fontSize: sm, 
              lineHeight: 2,
              text: 'TO BE COMPLETED BY CANADIAN SHIPPER WHEN THE GOODS DESCRIBED ABOVE ARE OF U.S. MANUFACTURE OR GROWTH. I, ________________________________________ , DECLARE THAT THE ARTICLES HEREIN SPECIFIED ARE, TO THE BEST OF MY KNOWLEDGE AND BELIEF, THE GROWTH PRODUCE OR MANUFACTURE OF THE UNITED STATES.  THAT THEY WERE EXPORTED FROM THE UNITED STATES FROM THE PORT OF ______________________________ ON OR ABOUT ____________________ , 20______  THAT THEY ARE RETURNED WITHOUT HAVING BEEN ADVANCED IN VALUE OR IMPROVED IN CONDITION BY ANY PROCESS OF MANUFACTURE OR OTHER MEANS. SIGNATURE:                       '
            },
          ]
        ]
      },
      layout: outlineLayout,
    },

    // 7th row final misc.
    {
      table: {
        widths: ['69.9%', '*'],
        body: [
          [
            {
              stack: [
                  {
                    table: {
                      widths: ['auto', 1, 'auto', 1, 'auto'],
                      body: [
                        [
                          { fontSize: sm, text: '17. ESTIMATED FREIGHT CHARGES: ', margin: [0, 8, 0, 0] },
                          { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                          { margin: [4,4,0,0], fontSize: chk, text: 'PREPAID' },
                          { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                          { margin: [4,4,0,0], fontSize: chk, text: 'COLLECT' },
                        ]
                      ]                                                              
                    },
                    layout: blankLayout,
                  },
                  { fontSize: sm, text: 'TO PORT OF EXIT:                                                TO DESTINATION: ', margin: [4, 8, 0, 8] },
              ]
            },
            { fontSize: sm, text: '18. IF ABOVE ARTICLES NOT SOLD, STATE THE REASON FOR EXPORT (LOAN, REPAIR, ETC.)', margin: [0, 8, 0, 0] },
          ],
          [
            {
              stack: [
                  { fontSize: sm, text: '19. MODE OF TRANSPORTATION FROM POINT OF EXIT:', margin: [0, 8, 0, 0] },
                  {
                    table: {
                      widths: [1, 'auto', 1, 'auto', 1, 'auto', 1, 'auto', 1, 'auto', '*', '90'],
                      body: [
                        [
                          { margin: [0,4,0,0], image: 'checked', width: 10 },
                          { margin: [4,4,0,0], fontSize: chk, text: 'ROAD' },
                          { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                          { margin: [4,4,0,0], fontSize: chk, text: 'RAIL' },
                          { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                          { margin: [4,4,0,0], fontSize: chk, text: 'WATER' },
                          { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                          { margin: [4,4,0,0], fontSize: chk, text: 'AIR' },
                          { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                          { margin: [4,4,0,0], fontSize: chk, text: 'OTHER' },
                          { text: ' ' },
                          {
                            margin: [0,-16,0,0],
                            stack: [
                              { fontSize: sm, text: '20. CONTAINERIZED', margin: [0, 8, 0, 0] },
                              {
                                table: {
                                  widths: [1, 'auto', 1, 'auto', 1],
                                  body: [
                                    [
                                      { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                                      { margin: [4,4,0,0], fontSize: chk, text: 'YES' },
                                      { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                                      { margin: [4,4,0,0], fontSize: chk, text: 'NO' },
                                    ]
                                  ]
                                },
                                layout: bottomLeftLayout,
                              }
                            ]
                          }
                        ]
                      ]                                                              
                    },
                    layout: blankLayout,
                  },
                  { fontSize: sm, text: '_____ SUBJECT TO DRAWBACK         _____ IMPORTED ON 1/60TH BASIS         _____ IMPORTED UNDER LICENSE', margin: [4, 10, 0, 8] },

                  { table: { widths: ['100%'], body : [['']]}, layout: topLayout},
                  {
                    table: {
                      widths: ['60%', '40%'],
                      body : [
                        [
                          {
                            stack: [
                              { fontSize: sm, text: '23. I HEREBY CERTIFY THAT THE INFORMATION GIVEN ABOVE IS TRUE AND COMPLETE IN EVERY RESPECT. GIVE FIRM NAME AND ADDRESS IF DIFFERENT FROM ABOVE.', margin: [0, 8, 0, 0], lineHeight: 2 },
                              { text: [{ fontSize: sm, text: 'Date  '},{ fontSize: md, text: shippingDate}] },
                              { text: [{ fontSize: sm, text: 'Signature  '},{ fontSize: md, text: customerCompany.proformaSignature}] },
                            ]
                          },
                          {
                            stack: [
                              { fontSize: md, text: rfq.customer.company, margin: [0, 8, 0, 20], alignment: 'center'},
                              { fontSize: sm, text: 'STATUS', margin: [0, 8, 0, 0] },
                              {
                                table: {
                                  widths: [1, 'auto', 1, 'auto', 1],
                                  body: [
                                    [
                                      { margin: [0,4,0,0], image: 'checked', width: 10 },
                                      { margin: [4,4,0,0], fontSize: chk, text: 'OWNER' },
                                      { margin: [0,4,0,0], image: 'unchecked', width: 10 },
                                      { margin: [4,4,0,0], fontSize: chk, text: 'AGENT' },
                                    ]
                                  ]
                                },
                                layout: blankLayout,
                              }
                            ],
                          }
                        ],
                      ]
                    },
                    layout: blankLayout
                  }
                
              ]
            },
            {
              stack: [
                { fontSize: sm, text: '22. EXPORT PERMIT NO.', margin: [0, 8, 0, 20] },
                { table: { widths: ['100%'], body : [['']]}, layout: topLayout},
                { fontSize: md, text: 'NOTICE', margin: [0, 8, 0, 0], alignment: 'center' },
                { fontSize: sm, text: 'THIS INVOICE DOES  NOT RELIEVE THE SHIPPER FROM  PRODUCING  SPECIAL OR COMMERCIAL  INVOICES  WHEN  REQUIRED.', margin: [0, 8, 0, 0], lineHeight: 2 },
              ]
            }
          ],
        ]
      },
      
    },




  ]};
  return pdfMake.createPdf(dd)

}



// WEBPACK FOOTER //
// ./src/utils/pdf.js